module.exports = require("./fr-NE");